<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="font-family:Arial;"><strong>List of Figures</strong></h1>
<table style="margin:auto; font-weight:bold;">
<colgroup>
<col width="25%"/>
<col width="50%"/>
</colgroup>
<thead>
<tr class="header">
<td align="right" style="border:0px solid white; padding-top:5px;"><strong>Figure 1:<br/></strong></td>
<td align="left" style="border:0px solid white;"><strong>Difference Between Phonology and Phonetics
(Articulation)</strong></td>
</tr>
</thead>
<tbody>
<tr class="odd">
<td align="right" style="border:0px solid white;"><strong>Figure 2:</strong></td>
<td align="left" style="border:0px solid white;">Components of Spoken Language</td>
</tr>
<tr class="even">
<td align="right" style="border:0px solid white;"><strong>Figure 3:</strong></td>
<td align="left" style="border:0px solid white;">Levels of Spoken Language </td>
</tr>
<tr class="odd">
<td align="right" style="border:0px solid white; padding-top:5px;"><strong>Figure 4:<br/><br/></strong></td>
<td align="left" style="border:0px solid white; ">Simple Classification System for ‘Underlying
Levels’ of Difficulty in Speech Sound<br/>
Disorders </td>
</tr>
<tr class="even">
<td align="right" style="border:0px solid white;"><strong>Figure 5:</strong></td>
<td align="left" style="border:0px solid white;">Speech Sound Disorder Tree</td>
</tr>
<tr class="odd">
<td align="right" style="border:0px solid white;"><strong>Figure 6:</strong></td>
<td align="left" style="border:0px solid white;">Tongue Thrust</td>
</tr>
<tr>
<td align="right" style="border:0px solid white;"><strong>Figure 7:<br/></strong></td>
<td align="left" style="border:0px solid white;">A Diagnostic Sheet for Diagnosis of Speech Sound
Disorder</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?68833f3b